<template>
  <div class="table-chair" style="min-width: 100%;">
    <!-- <vue-resizable :style="[{zIndex: isSeatSelected ? '16' : '-1'}, {width: '100%'}, {height: '100%'}]"> -->
      <!-- <vue-draggable-resizable :w="500" :h="500" :style="[{zIndex: isSeatSelected ? '16' : '-1'}]" @dragging="onDrag" @resizing="onResize" :parent="true"> -->
    <div class="card" id="table-canvas">
      <div id="screen-share-panel"></div>
      <!-- <div id="offline">
        OFFLINE
      </div> -->
      <div
        style="position: absolute; top: 5px;right: 5px;border-radius: 6px; z-index: 100;background: rgba(10, 10, 10, 0.75);"
      >
        <div
          v-if="networkState === '4g'"
          title="Strong Connection"
          id="strongNetworkIcon"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="#2ecc71">
                <path
                  d="M112.875,21.5v129h32.25v-129zM69.875,59.125v91.375h32.25v-91.375zM26.875,96.75v53.75h32.25v-53.75z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <div v-else-if="networkState === '3g'" title="Bad Connection">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal"
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="#f1c40f">
                <path
                  d="M112.875,21.5v129h32.25v-129zM123.625,32.25h10.75v107.5h-10.75zM69.875,59.125v91.375h32.25v-91.375zM26.875,96.75v53.75h32.25v-53.75z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <div
          v-else-if="networkState === '2g' || networkState === 'slow-2g'"
          title="Poor Connection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="32"
            height="32"
            viewBox="0 0 172 172"
            style=" fill:#000000;"
          >
            <g
              fill="none"
              fill-rule="nonzero"
              stroke="none"
              stroke-width="1"
              stroke-linecap="butt"
              stroke-linejoin="miter"
              stroke-miterlimit="10"
              stroke-dasharray=""
              stroke-dashoffset="0"
              font-family="none"
              font-weight="none"
              font-size="none"
              text-anchor="none"
              style="mix-blend-mode: normal;"
            >
              <path d="M0,172v-172h172v172z" fill="none"></path>
              <g fill="#f1c40f">
                <path
                  d="M112.875,21.5v129h32.25v-129zM123.625,32.25h10.75v107.5h-10.75zM69.875,59.125v91.375h32.25v-91.375zM80.625,69.875h10.75v69.875h-10.75zM26.875,96.75v53.75h32.25v-53.75z"
                ></path>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="ag-btn-group">
        <div style="display: flex; justify-content: space-between;">
          <div style="display: flex; justify-content: space-between;">
            <span
              class="ag-btn videoControlBtn tooltip"
              @click="handleCamera"
              id="camera"
              title="Enable/Disable Video"
            >
              <i class="fas fa-video-slash"></i>
              <i class="fas fa-video"></i>
              <span class="tooltiptext">Enable/Disable Camer</span>
            </span>
            <span
              class="ag-btn audioControlBtn tooltip"
              @click="handleMic"
              id="Mic"
              title="Enable/Disable Audio"
            >
              <i class="fas fa-microphone-slash"></i>
              <i class="fas fa-microphone"></i>
              <span class="tooltiptext">Enable/Disable Microphone</span>
            </span>
          </div>
        </div>
        <div
          style="display: flex; justify-content: space-between; float: right;"
        >
          <span
            v-if="isScreenBeingSharedByRemote && !isActiveTableScreenShare"
            class="ag-btn fullscreenControlBtn"
            id="Screen"
            @click="handleFullscreen"
            title="Full Screen Video Share"
          >
            <div style="display: grid;">
              <i
                class="fas fa-compress"
                style="margin-left: 12px; padding-bottom: 4px;"
              ></i>
              <i style="font-size: 10px; margin-top: -5px;" class="text-primary"
                >Full screen</i
              >
            </div>
          </span>
          <button
            v-if="!isActiveTableScreenShare"
            @click="handleScreenShare"
            class="ag-btn displayModeBtn d-none d-md-block"
            id="screen-share"
            title="Start Screenshare"
            style="padding: 5px 20px;"
            :class="{ disableButton: isScreenBeingSharedByRemote }"
            :disabled="this.$store.state.isTableScreenShare"
          >
            <div style="display: grid;">
              <i class="fas fa-share" style="margin-left: 12px;"></i>
              <i style="font-size: 10px;" class="text-primary">Screen Share</i>
            </div>
          </button>
          <span
            @click="handleLeaveTable"
            class="ag-btn displayModeBtn"
            id="leave-table"
            title="Switch Display Mode"
            style="
              padding: 8px;
              background: rgba(158, 6, 6, 0.73);
              color: rgb(255, 255, 255);
              border: 1px solid rgb(101, 101, 101);
              box-shadow: 0 0 10px #2b2b2b;
            "
          >
            <div style="display: grid;">
              <!--              <i class="fas fa-chair" style="margin-left: 12px"></i>-->
              <i
                style="
                  font-size: 14px;
                  font-style: normal;
                  font-weight: bold;
                  color: #fff !important;
                "
                class="text-primary"
                >Leave Table</i
              >
            </div>
          </span>
        </div>
      </div>
    </div>
      <!-- </vue-draggable-resizable> -->
    <!-- </vue-resizable> -->
    <div class="card" v-if="videoStreamList.length == 0 && isSupported">
      <div class="card-body" style="border-radius: 12px;">
        <div class="social-header">
          <h5 class="mt-1 pt-1" v-if="this.$store.state.isBreak">
            <b>Stage is this way & networking break is going.</b>
          </h5>
          <h5 class="mt-1 pt-1" v-else-if="this.$store.state.isEnd">
            <b>Stage is this way & session has ended</b>
          </h5>
          <h5 class="mt-1 pt-1" v-else>
            <b>Stage is this way.</b>
          </h5>
          <p class="mt-1">
            Sit on a virtual table below and video chat with fellow
            participants.
          </p>
          <button
            class="btn-success btn d-none"
            id="grab-seat"
            @click="grabSeat"
          >
            Grab a Seat
          </button>
          <button
            class="btn-danger btn m-3 d-none"
            id="leave-seat"
            @click="leaveSeat"
          >
            Leave Seat
          </button>
        </div>
        <div class="container" style="border-radius: 5px;">
          <div
            class="alert alert-danger"
            v-if="this.$store.state.errorMessage !== ''"
          >
            {{ this.$store.state.errorMessage }}
          </div>
          <div class="row justify-content-center text-center">
            <div
              style="
                background-color: #2e2d2e;
                border-radius: 12px;
                margin: 10px;
                border: 1px solid #979797;
              "
              v-for="(x, i) in this.$store.state.tables"
              :key="i"
              :id="'t'+x.table_id"
            >
              <div
                class="table-item col-12 col-sm-6 col-md-4"
                :id="'table-' + x.table_id"
              >
                <label class="text-white m-1 text-center chair-label"
                  >Click on chair to grab a seat</label
                >
                <div class="round-table" id="round-table">
                  <span
                    style="font-size: 18px; font-weight: bold; color: #000;"
                    >{{ i + 1 }}</span
                  >
                </div>
                <div
                  class="round-table-loader"
                  v-if="isSeatSelected && x.table_id == localTableId"
                >
                  <small>initializing video call..</small>
                </div>
                <div
                  class="chair chair-up"
                  v-if="x.chair_1 === ''"
                  id="chair-up"
                  @click="selectSeat(x.table_id, 1)"
                ></div>

                <div class="chair chair-up" v-else>
                  <img
                    :src="x.chair_1.photoURL"
                    alt
                    class="table-image-preview-top"
                  />

                  <!-- <img  class="tooltiptext-top" :src="x.chair_1.photoURL" style="width: 50px" alt=""> -->
                  <span class="Triangle"></span>
                  <span class="tooltiptext-top">
                    <img
                      :src="x.chair_1.photoURL"
                      style="
                        width: 50px;
                        height: 50px;
                        border-radius: 8px;
                        border: solid 1px #f1f1f1;
                        margin-right: 10px;
                      "
                      alt
                    />
                    <strong>{{ x.chair_1.name.slice(0, 10) }}...</strong>
                    <br />
                    <!-- <small style="font-size: 10px">{{x.chair_1.email}}</small> -->
                  </span>
                </div>
                <div
                  class="chair chair-down"
                  id="chair-down"
                  v-if="x.chair_2 === ''"
                  @click="selectSeat(x.table_id, 2)"
                ></div>
                <div class="chair chair-down" v-else>
                  <img
                    :src="x.chair_2.photoURL"
                    alt
                    class="table-image-preview-bottom"
                  />
                  <span class="Triangle"></span>
                  <span class="tooltiptext">
                    <img
                      :src="x.chair_2.photoURL"
                      style="
                        width: 50px;
                        height: 50px;
                        border-radius: 8px;
                        border: solid 1px #f1f1f1;
                        margin-right: 10px;
                      "
                      alt
                    />
                    <strong> {{ x.chair_2.name.slice(0, 10) }}...</strong>
                    <br />
                    <!-- {{x.chair_2.email}} -->
                  </span>
                </div>
                <div
                  class="chair chair-right"
                  id="chair-right"
                  v-if="x.chair_3 === ''"
                  @click="selectSeat(x.table_id, 3)"
                ></div>
                <div class="chair chair-right" v-else>
                  <img
                    :src="x.chair_3.photoURL"
                    alt
                    class="table-image-preview-right"
                  />
                  <span class="Triangle-right"></span>
                  <span class="tooltiptext-right">
                    <img
                      :src="x.chair_3.photoURL"
                      style="width: 50px; height: 50px; border-radius: 8px; border: solid 1px #f1f1f1; margin-right: 10px"
                      alt
                    />
                    <strong>{{ x.chair_3.name.slice(0, 10) }}...</strong>
                    <br />
                    <!-- {{x.chair_3.email}} -->
                  </span>
                </div>
                <div
                  class="chair chair-left"
                  v-if="x.chair_4 === ''"
                  id="chair-left"
                  @click="selectSeat(x.table_id, 4)"
                ></div>
                <div class="chair chair-left" v-else>
                  <img
                    :src="x.chair_4.photoURL"
                    alt
                    class="table-image-preview-left"
                  />
                  <span class="Triangle-left"></span>
                  <span class="tooltiptext-left">
                    <img
                      :src="x.chair_4.photoURL"
                      style="width: 50px; height: 50px; border-radius: 8px; border: solid 1px #f1f1f1; margin-right: 10px"
                      alt
                    />
                    <strong>{{ x.chair_4.name.slice(0, 10) }}...</strong>
                    <br />
                    <!-- <small>{{x.chair_4.email}}</small> -->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="!isSupported" class="card">
      <h4 style="padding: 12px">{{ errorSupportMessage }}</h4>
    </div>
    <div
      v-if="isScreenShareLoaded && !isActiveTableScreenShare && isSeatSelected"
      class="text-center"
    >
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          background: #000;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          style="position: absolute;top: 50%;left: 50%;transform: translate(-70%, -50%);text-align: center;"
        >
          <img src="../../assets/loader.gif" width="70" height="70" />
          <p>Loading..</p>
        </div>
      </div>
    </div>
    <div v-if="isActiveTableScreenShare" class="text-center">
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          background: #000;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <h4>You are presenting...</h4>
        <button
          @click="handleStopScreenShare"
          class="btn btn-outline-danger"
          id="stop-share"
          title="Switch Display Mode"
          style="padding: 5px 20px;width: 140px;height: 50px;"
        >
          Stop Share
        </button>
      </div>
      <div
        id="panel"
        style="
          position: absolute;
          top: 0;
          right: 0;
          z-index: 10;
          background: #000;
          width: 200px;
          height: auto;
          display: flex;
          flex-direction: column;
        "
      ></div>
    </div>
    <!-- <span class="tooltiptext">Tooltip text</span> -->

  </div>
</template>

<script>
import AgoraRTC from "agora-rtc-sdk";
import UAParser from "ua-parser-js";
import { merge } from "lodash";
import jquery from "jquery";
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
var DetectRTC = require("detectrtc");

const parser = new UAParser();
const userAgentInfo = parser.getResult();

var condition = navigator.onLine ? true : false;
console.log("Condition: ", condition);
// document.getElementById('offline').style.display = condition ? 'none' : 'block'
window.addEventListener("load", function() {
  function updateOnlineStatus() {
    condition = navigator.onLine ? true : false;
    console.log("ConditionInside: ", condition);
    if (condition === true) {
      document.getElementById("offline").style.display = "none";
    } else {
      document.getElementById("offline").style.display = "block";
    }
  }

  window.addEventListener("online", updateOnlineStatus);
  window.addEventListener("offline", updateOnlineStatus);
});

// document.getElementById('offline').style.display = condition ? 'block' : 'none'

export default {
  components: {

  },
  data() {
    return {
      auditoriumAudio: "",
      audio: "",
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      isActiveTableScreenShare: false,
      user: {
        name: "",
      },
      isScreenShareLoaded: false,
      screenShareTableId: 0,
      isSupported: false,
      errorSupportMessage: "",
      talbeUid: "",
      screenUid: "",
      videoTableToken: "",
      screenShareToken: "",
      tableChannel: "",
      tableVideoClient: "",
      tableScreenClient: "",
      videoStreamList: [],
      appID: "69ef6e3390ff4e32b01d68cf54610419",
      videoCalllocalStream: "",
      videoCallScreenStream: "",
      memberList: [],
      localTableId: "",
      localChairId: "",
      isSeatSelected: false,
      isScreenBeingSharedByRemote: false,
      networkState: "",
      audioFlag: true,
      videoFlag: true,
      isOnline: true,
    };
  },
  computed: {},
  watch: {
    // videoStreamList() {
    //   console.log(
    //     "%c:video stream",
    //     "background: #ff00dd; color: #00ff00",
    //     this.videoStreamList
    //   );
    // },
  },
  created() {
    const $ = this;
    window.addEventListener("beforeunload", this.handleLeaveTable);
    // this.checkBrowserSupport();
    if (AgoraRTC.checkSystemRequirements()) {
      $.isSupported = true;
    } else {
      $.errorSupportMessage =
        "Our platform currently do not support this version of hardware and software. Kindly upgrade your device. Check our platform requirements here.";
    }

    // get Supported Codec
    AgoraRTC.getSupportedCodec().then(function(result) {
      console.log(`Supported video codec: ${result.video.join(",")}`);
      console.log(`Supported audio codec: ${result.audio.join(",")}`);
    });
    this.isActiveTableScreenShare = false;
  },
  mounted() {
    const $ = this;
    $.getTableStructureFunction();
    $.auditoriumAudio = new Audio($.$store.state.auditoriumAudio);
    $.auditoriumAudio.play();
    $.auditoriumAudio.loop = true;
    $.auditoriumAudio.volume = .1;
    jquery(".chair").on("mouseover" ,() => {
       console.info('on chair ...');
       $.audio = new Audio("https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/chair3.mp3");
       $.audio.play();
    })
    jquery(".chair").on("mouseleave" ,() => {
      $.audio.stop();
      $.audio.currentTime = 0;
    })
    jquery(".table-item").on("click" ,() => {
      $.audio = new Audio("https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/knock.mp3");
      $.audio.play();
    })
    $.$root.$on("exit", () => {
      // this.$store.state.isLive = false;
      // this.$store.state.streamCount = 0;
      $.handleLeaveTable();
    });
    $.$root.$on("screenShareLoaderStartedForTable", (tableId) => {
      // console.log('loader tabled id: ', tableId)
      console.log('screen loader: ', this.isScreenShareLoaded, ' loader id: ', tableId, ' ', this.localTableId)
      if(tableId === this.localTableId) {
        this.isScreenShareLoaded = true;
        this.screenShareTableId = tableId;
      }
    });
    $.$root.$on("screenShareLoaderStoppedForTable", (tableId) => {
      this.isScreenShareLoaded = false;
      this.screenShareTableId = tableId;
    });
    $.$root.$on("clientScreenShareHasStartedForTable", (uid) => {
      console.log('Table data: ',$.screenShareTableId, ' ', $.localTableId, ' ', uid);
      if($.localTableId === $.screenShareTableId){
        $.isScreenBeingSharedByRemote = true;

      }
    });
    $.$root.$on("clientScreenShareHadStoppedForTable", (uid) => {
      console.log('uid: ', uid);
      $.isScreenBeingSharedByRemote = false;
      $.canvasLayout();
    });
    $.$root.$on("getTableData", function() {
      $.getTableStructureFunction();
    });
    $.$root.$on("handleLeaveTable_1", function(uid) {
      if (uid == $.uid) {
        $.handleLeaveTable_1(uid);
      }
    });
    $.$root.$on("handlesubmitSetting", (packet) => {
      console.log(" video call packet: ", packet);
      packet.req.forEach((item) => {
        if (
          item.type === "video" &&
          item.deviceId !== this.$store.state.cameraId
        ) {
          $.videoCalllocalStream.switchDevice(
            `video`,
            `${item.deviceId}`,
            function() {
              $.$toast.open({
                message: "Device switch success",
                type: "success",
                position: "top",
              });
            },
            function(err) {
              console.log(err);
            }
          );
          this.$store.state.cameraId = item.deviceId;
        }
        if (
          item.type === "audio" &&
          item.deviceId !== this.$store.state.microphoneId
        ) {
          $.videoCalllocalStream.switchDevice(
            `audio`,
            `${item.deviceId}`,
            function() {
              $.$toast.open({
                message: "Device switch success",
                type: "success",
                position: "top",
              });
            },
            function(err) {
              console.log(err);
            }
          );
          this.$store.state.microphoneId = item.deviceId;
        }
        if(item.type === "auditoriumAudio"){
          $.auditoriumAudio.pause();
          $.$store.state.auditoriumAudio = item.url;
          $.auditoriumAudio = new Audio(item.url);
          $.auditoriumAudio.play();
          $.auditoriumAudio.volume = item.volume;
          $.auditoriumAudio.loop = true;
        }
      });
    });
  },
  methods: {
    onResize: function (x, y, width, height) {
      this.x = x
      this.y = y
      this.width = width
      this.height = height
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
    },
    canvasLayout() {
      const $ = this;

      let tc = document.querySelector("#table-canvas");
      tc.setAttribute(
        "style",
        `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden;`
      );

      let panel = document.querySelector("#screen-share-panel");
      panel.setAttribute(
        "style",
        `display: flex;flex-direction: column;width: 15%; height: 85vh;  z-index: 99;`
      );

      let length = $.videoStreamList.length;

      if ($.isScreenBeingSharedByRemote) {
        $.videoStreamList.forEach((stream, index) => {
          let width = "";
          let height = "15vh";
          if (stream.getId() === 100000001) {
            width = "85%";
            height = "85vh";
          } else {
            if (index === 7) {
              let breaker = document.createElement("div");
              breaker.style.width = "0%";
              breaker.style.height = "0%";
              breaker.style.flexBasis = "100%";
              let parent = document.querySelector("#screen-share-panel");
              parent.insertBefore(breaker, parent.children[index + 1]);
            }
            width = "100%";
          }
          let label = document.getElementById(`video-info-${stream.getId()}`);
          // console.log("label: ", label);
          if (label !== null) {
            label.style.bottom = "0";
            label.style.height = "25px";
            label.firstChild.style.fontSize = ".9em";
            if (label.childNodes[1] != null) {
              label.childNodes[1].style.visibility = "hidden";
            }
          }
          if (document.querySelector(`#ag-item-${stream.getId()}`)) {
            document.querySelector(
              `#ag-item-${stream.getId()}`
            ).style.width = width;
            document.querySelector(
              `#ag-item-${stream.getId()}`
            ).style.height = height;
          }
        });
      } else {
        let panel = document.querySelector("#screen-share-panel");
        panel.setAttribute(
          "style",
          `display:flex; flex-wrap: wrap; width: 100%;height: 85vh;flex-direction: column`
        );

        if (length === 17) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "";
            let height = "";
            if (index > 0) {
              width = "33.2%";
            } else {
              width = "16.6%";
              height = "21.25vh";
            }
            height = "85vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.width = "120px";
              label.style.height = "60px";
              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 16) {
          $.videoStreamList.forEach((stream) => {
            let width = "25%";
            let height = "21.25vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 15) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "20%";
            let height = "";
            if (index == 0) {
              height = "85vh";
            } else if (index > 0 && index < 3) {
              height = "42.5vh";
            } else {
              height = "21.25vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 14) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index < 2) {
              height = "42.5vh";
            } else {
              height = "21.25vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 13) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index === 0) {
              height = "85vh";
            } else {
              height = "21.25vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 12) {
          $.videoStreamList.forEach((stream) => {
            let width = "25%";
            let height = "28.3vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 11) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index < 2) {
              height = "42.5vh";
            } else {
              height = "28.3vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 10) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index > 0) {
              height = "28.3%";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 9) {
          $.videoStreamList.forEach((stream) => {
            let width = "33.3%";
            let height = "28.3vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 8) {
          $.videoStreamList.forEach((stream) => {
            let width = "25%";
            let height = "42.5vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 7) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "25%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 6) {
          $.videoStreamList.forEach((stream) => {
            let width = "33.3%";
            let height = "42.5vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 5) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "33.3%";
            let height = "";
            if (index > 0) {
              height = "42.5";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 4) {
          $.videoStreamList.forEach((stream) => {
            let width = "50%";
            let height = "42.5vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 3) {
          $.videoStreamList.forEach((stream, index) => {
            let width = "50%";
            let height = "";
            if (index > 0) {
              height = "42.5vh";
            } else {
              height = "85vh";
            }
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 2) {
          $.videoStreamList.forEach((stream) => {
            let width = "50%";
            let height = "85vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        } else if (length === 1) {
          $.videoStreamList.forEach((stream) => {
            let width = "100%";
            let height = "85vh";
            if (document.querySelector(`#ag-item-${stream.getId()}`)) {
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.width = width;
              document.querySelector(
                `#ag-item-${stream.getId()}`
              ).style.height = height;
            }
            let label = document.getElementById(`video-info-${stream.getId()}`);
            // console.log("label: ", label);
            if (label !== null) {
              label.style.bottom = "120px";
              label.style.height = "auto";

              label.firstChild.style.fontSize = "12px";
              if (label.childNodes[1] != null) {
                label.childNodes[1].style.visibility = "visible";
              }
            }
          });
        }

      }
    },
    checkBrowserSupport() {
      const $ = this;
      DetectRTC.load(function() {
        let browserName = DetectRTC.browser.name;
        let browserVersion = DetectRTC.browser.version;
        let osName = DetectRTC.osName;
        let osVersion = DetectRTC.osVersion;
        console.log(
          `browser name: ${browserName}, browser version: ${browserVersion}, os name: ${osName}, os version: ${osVersion}`
        );
        if (browserName === "Chrome" && browserVersion >= 58) {
          if (osName === "Android" && osVersion >= 4.1) {
            $.isSupported = true;
          } else if (osName === "macOS" && osVersion >= 10) {
            $.isSupported = true;
          } else if (osName === "Windows" && osVersion >= 7) {
            $.isSupported = true;
          }
        } else if (browserName === "Firefox" && browserVersion >= 56) {
          if (osName === "macOS" && osVersion >= 10) {
            $.isSupported = true;
          } else if (osName === "Windows" && osVersion >= 7) {
            $.isSupported = true;
          }
        } else if (browserName === "Safari" && browserVersion >= 11) {
          if (osName === "macOS" && osVersion >= 10) {
            $.isSupported = true;
          } else if (osName === "iOS" && osVersion >= 11) {
            $.isSupported = true;
          }
        } else if (browserName === "Opera" && browserVersion >= 45) {
          if (osName === "macOS" && osVersion >= 10) {
            $.isSupported = true;
          } else if (osName === "Windows" && osVersion >= 7) {
            $.isSupported = true;
          }
        }
        if (!$.isSupported) {
          if (browserName === "Chrome") {
            $.errorSupportMessage = `We currently do not support on ${browserName}'s / ${browserVersion} version. Kindly update your browser version above or equal to 58`;
          } else if (browserName === "Firefox") {
            $.errorSupportMessage = `We currently do not support ${browserName}'s / ${browserVersion} version. Kindly update your browser version above or equal to 56`;
          } else if (browserName === "Safari") {
            $.errorSupportMessage = `We currently do not support ${browserName}'s / ${browserVersion} version. Kindly update your browser version above or equal to 11`;
          } else if (browserName === "Opera") {
            $.errorSupportMessage = `We currently do not support ${browserName}'s / ${browserVersion} version. Kindly update your browser version above or equal to 45`;
          }
        }
      });
    },
    getFullscreenElement() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullscreenElement ||
        document.msFullscreenElement
      );
    },
    permissionDetect() {
      var DetectRTC = require("detectrtc");
      const $ = this;
      DetectRTC.load(function() {
        if (DetectRTC.isWebsiteHasMicrophonePermissions === false) {
          $.$store.state.errorMessage =
            "Permission to use your camera or microphone is missing. Please allow camera and mic access for an interactive experience.";
          alert(
            "Permission to use your camera or microphone is missing. Please allow camera and mic access for an interactive experience."
          );
          // alert('Permission to use your camera or micophone is missing. Please allow camera and mic access for am interactive experience.');
        }

        if (DetectRTC.isWebsiteHasWebcamPermissions === false) {
          // alert('Please install an external microphone device.');
          $.$store.state.errorMessage =
            "Permission to use your camera or microphone is missing. Please allow camera and mic access for an interactive experience.";
          alert(
            "Permission to use your camera or microphone is missing. Please allow camera and mic access for an interactive experience."
          );
        }

        if (
          DetectRTC.hasSpeakers === false &&
          (DetectRTC.browser.name === "Chrome" ||
            DetectRTC.browser.name === "Edge")
        ) {
          alert("Oops, your system can not play audios.");
        }
      });
    },
    toggleFullscreen() {
      if (this.getFullscreenElement()) {
        document.exitFullscreen();
      } else {
        document
          .getElementById("ag-item-100000001")
          .requestFullscreen()
          .catch(console.log);
      }
    },
    grabSeat() {
      const $ = this;
      $.$store.state.tables.forEach((x, index) => {
        if (x["chair_1"] === "") {
          this.selectSeat(index + 1, 1);
          return;
        } else if (x["chair_2"] === "") {
          this.selectSeat(index + 1, 2);
          return;
        } else if (x["chair_3"] === "") {
          this.selectSeat(index + 1, 3);
          return;
        } else if (x["chair_4"] === "") {
          this.selectSeat(index + 1, 4);
          return;
        }
      });
    },
    leaveSeat() {
      const $ = this;
      $.$store.state.tables.forEach(() => {
        this.handleLeaveTable();
      });
    },
    getTableStructureFunction() {
      this.channel = this.$route.params.name;
      this.user = JSON.parse(localStorage.getItem("user_info"));
      let da = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventTableStructureWithId", da).then((resp) => {
        if (resp.data.status === "success") {
          // console.log("chair selected, get data.", resp);
          resp.data.data.forEach((x) => {
            console.log(
              "seat: ",
              x["chair_1"]["uid"],
              " ",
              x["chair_2"]["uid"],
              " ",
              x["chair_3"]["uid"],
              " ",
              x["chair_4"]["uid"]
            );
            if (x["chair_1"] !== "") {
              if (x["chair_1"]["uid"] == this.user.uid) {
                this.selectSeat(x["table_id"], 1);
              }
            } else if (x["chair_2"] !== "") {
              if (x["chair_2"]["uid"] == this.user.uid) {
                this.selectSeat(x["table_id"], 2);
              }
            } else if (x["chair_3"] !== "") {
              if (x["chair_3"]["uid"] == this.user.uid) {
                this.selectSeat(x["table_id"], 3);
              }
            } else if (x["chair_4"] !== "") {
              if (x["chair_4"]["uid"] == this.user.uid) {
                this.selectSeat(x["table_id"], 4);
              }
            }
          });
          this.listOfMembers();
        }
      });
    },

    handleMuteAudio(uid) {
      this.audioFlag = false;
      jquery(`#video-info-${uid}>.main-div>.audio-icon-div>.audio`).show();
    },
    handleUnmuteAudio(uid) {
      this.audioFlag = true;
      jquery(`#video-info-${uid}>.main-div>.audio-icon-div>.audio`).hide();
    },
    handleMuteVideo(uid) {
      this.videoFlag = false;
      // console.log("UID: ", uid);
      jquery(`#video-info-${uid}>.main-div>.video-icon-div>.video`).show();
    },
    handleUnmuteVideo(uid) {
      this.videoFlag = true;
      jquery(`#video-info-${uid}>.main-div>.video-icon-div>.video`).hide();
    },
    // No Need
    isFirefox() {
      return userAgentInfo.browser.name === "Firefox";
    },
    // No need
    isCompatibleChrome() {
      if (userAgentInfo.browser.name === "Chrome") {
        const major = userAgentInfo.browser.major;
        if (major >= 72) return true;
      }
      return false;
    },

    handleScreenShare() {
      const $ = this;
      $.$store.state.isTableScreenShare = true;
      //  initialize the screen share
      $.getScreenShareTableTokenFunction($.localTableId);
      $.isScreenBeingSharedByRemote = true;
    },
    handleStopScreenShare() {
      const $ = this;
      $.isActiveTableScreenShare = false;
      $.$store.state.isTableScreenShare = false;
      $.isScreenBeingSharedByRemote = false;

      $.handleStopShare();
    },
    handleStopShare() {
      const $ = this;

      $.removeStream($.videoCallScreenStream.getId());
      //   $.tableScreenClient &&
      //     $.tableScreenClient.unpublish($.videoCalllocalStream);
      $.videoCallScreenStream && $.videoCallScreenStream.close();
      $.tableScreenClient &&
        $.tableScreenClient.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
        $.canvasLayout();
      $.$root.$emit("clientScreenShareStoppedForTable");
    },
    leaving() {
      alert("i am called");
      const $ = this;
      this.videoStreamList = [];
      this.handleLeaveTable();
      $.$store.state.tables.forEach((table) => {
        if ($.localTableId == table.table_id) {
          table[`chair_+ ${$.localChairId}`] = "";
          $.$root.$emit("deleteMeFromYourRecord", {
            tableId: $.localTableId,
            chairId: $.localChairId,
          });
        }
      });
      // let da = {
      //   channel_id: this.$route.params.session,
      // };
      // this.$store.dispatch("storeEventTableStructure", da).then((resp) => {
      //   if (resp.data.status === "success") {
      //     console.log("Table data");
      //   }
      // });
    },
    handleCamera(e) {
      e.currentTarget.classList.toggle("off");

      if (this.videoCalllocalStream.isVideoOn()) {
        this.$toast.open({
          message: "Video is disable",
          type: "info",
          position: "bottom",
        });
        this.videoCalllocalStream.disableVideo();
        let targetElement = document.getElementById(`player_${this.user.uid}`);
        jquery(`#video${this.user.uid}`).hide();
        var img = document.createElement("img");
        img.src = `${this.user.photoURL}`;
        img.style.position = "absolute";
        img.setAttribute("id", "user_photo_client");
        img.style.top = "50%";
        img.style.left = "50%";
        img.style.transform = "translate(-50%, -50%)";

        targetElement.appendChild(img);
      } else {
        this.$toast.open({
          message: "Video is enable",
          type: "success",
          position: "bottom",
        });
        let userPhoto = document.getElementById(`user_photo_client`);
        userPhoto.remove();
        jquery(`#video${this.user.uid}`).show();
        this.videoCalllocalStream.enableVideo();
      }
    },
    handleMic(e) {
      e.currentTarget.classList.toggle("off");
      if (this.videoCalllocalStream.isAudioOn()) {
        this.$toast.open({
          message: "Mute",
          type: "info",
          position: "bottom",
        });
        this.videoCalllocalStream.disableAudio();
      } else {
        this.$toast.open({
          message: "Unmute",
          type: "success",
          position: "bottom",
        });
        this.videoCalllocalStream.enableAudio();
      }
    },
    handleFullscreen() {
      // console.log(this.screenShareUid);
      this.toggleFullscreen();
    },
    handleLeaveTable() {
      const $ = this;
      //document.getElementById("strongNetworkIcon").style.display = "block";
      // if (
      //   document.querySelector(".audioControlBtn").classList.contains("off")
      // ) {
      //   document.querySelector(".audioControlBtn").classList.remove("off");
      // }
      $.audio = new Audio("https://meetbeans-data.s3.ap-south-1.amazonaws.com/sound_effects/exit.mp3");
      $.audio.play();
      if ($.isActiveTableScreenShare) {
        $.handleStopScreenShare();
      }

      $.isSeatSelected = false;
      $.auditoriumAudio.play();
      this.tableVideoClient &&
        this.tableVideoClient.unpublish(this.videoCalllocalStream);
      this.videoCalllocalStream && this.videoCalllocalStream.close();
      this.tableVideoClient &&
        this.tableVideoClient.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );
      $.$root.$emit("updateRecordOnLeave", {
        tableId: $.localTableId,
        chairId: $.localChairId,
      });
      let chair_id = "chair_" + $.localChairId;
      $.$store.state.tables.forEach((x) => {
        if (x.table_id == $.localTableId) {
          x[chair_id] = "";
        }
      });
      // sending data to backend
	    if ($.localChairId != "") {
        let da = {
          channel_id: this.$route.params.session,
          table_id: $.localTableId,
          chair_id: chair_id
        };
        this.$store.dispatch("LeaveEventTableStructureWithId", da).then((resp) => {
          if (resp.data.status === "success") {
            console.log("chair selected, store data.");
          } else {
            console.error(resp.data);
          }
        });
	    }
      if ($.videoStreamList.length > 0) {
        $.videoStreamList.forEach((stream) => {
          let obj = document.querySelector("#ag-item-" + stream.getId());
          obj.remove();
        });
      }
      this.videoCalllocalStream = "";
      this.videoStreamList = [];
      this.tableVideoClient = "";
      if (document.getElementById("table-canvas")) {
        document.getElementById("table-canvas").style.display = "none";
        document
          .getElementById("table-canvas")
          .classList.remove("column-for-two");
      }
      document.querySelector(".audioControlBtn").classList.remove("off");
      document.querySelector(".videoControlBtn").classList.remove("off");
    },
    getIds(uid) {
      let tableId;
      let chairId = 0;
      this.$store.state.tables.forEach((x) => {
        if (x["chair_1"] !== "") {
          if (x["chair_1"]["uid"] == uid) {
            tableId = x["table_id"];
            chairId = 1;
          }
        } else if (x["chair_2"] !== "") {
          if (x["chair_2"]["uid"] == uid) {
            tableId = x["table_id"];
            chairId = 2;
          }
        } else if (x["chair_3"] !== "") {
          if (x["chair_3"]["uid"] == uid) {
            tableId = x["table_id"];
            chairId = 3;
          }
        } else if (x["chair_4"] !== "") {
          if (x["chair_4"]["uid"] == uid) {
            tableId = x["table_id"];
            chairId = 4;
          }
        }
      });
      return { tableId, chairId };
    },
    handleLeaveTable_1(uid) {
      const $ = this;

      let { tableId: table_id, chairId: chair_id } = $.getIds(uid);
      // console.log("vs ids: ", table_id, chair_id);

      // if (
      //   document.querySelector(".audioControlBtn").classList.contains("off")
      // ) {
      //   document.querySelector(".audioControlBtn").classList.remove("off");
      // }
      $.isSeatSelected = false;
      this.tableVideoClient &&
        this.tableVideoClient.unpublish(this.videoCalllocalStream);
      this.videoCalllocalStream && this.videoCalllocalStream.close();
      this.tableVideoClient &&
        this.tableVideoClient.leave(
          () => {
            console.log("Client succeed to leave.");
          },
          () => {
            console.log("Client failed to leave.");
          }
        );

      document.querySelector(".audioControlBtn").classList.remove("off");
      document.querySelector(".videoControlBtn").classList.remove("off");
      chair_id = "chair_" + chair_id;
      $.$store.state.tables.forEach((x) => {
        if (x.table_id == table_id) {
          x[chair_id] = "";
        }
      });

      $.$root.$emit("updateRecordOnLeave", {
        tableId: table_id,
        chairId: chair_id,
      });
      // sending data to backend
      let da = {
        channel_id: this.$route.params.session,
        table_id: $.localTableId,
        chair_id: chair_id

      };
      this.$store.dispatch("LeaveEventTableStructureWithId", da).then((resp) => {
        if (resp.data.status === "success") {
          console.log("chair selected, store data.");
        } else {
          console.error(resp.data);
        }
      });
      if ($.videoStreamList.length > 0) {
        $.videoStreamList.forEach((stream) => {
          let obj = document.querySelector("#ag-item-" + stream.getId());
          obj.remove();
        });
      }
      this.videoCalllocalStream = "";
      this.videoStreamList = [];
      this.tableVideoClient = "";
      if (document.getElementById("table-canvas")) {
        document.getElementById("table-canvas").style.display = "none";
        document
          .getElementById("table-canvas")
          .classList.remove("column-for-two");
      }
    },
    selectSeat: function(tableId, chairId) {
      const $ = this;
      $.isScreenBeingSharedByRemote = false;
      if (!$.isSeatSelected) {
        $.isSeatSelected = true;
        $.auditoriumAudio.pause();

        $.localTableId = tableId;
        $.localChairId = chairId;
        let chair_id = "chair_" + chairId;
        $.$toast.open({
          message: "Loading...",
          type: "info",
          position: "top",
        });
        let da = {
          channel_id: this.$route.params.session,
          table_id: tableId,
          chair_id: chair_id
        };
        let tables = $.$store.state.tables
	      console.log(tables)
        this.$store.dispatch("storeEventTableStructureWithId", da).then((resp) => {
          if (resp.data.status === "success") {
            tables.forEach((x) => {
              if (x.table_id == tableId) {
                if (x[chair_id] == ""){
                  let data = {
                    id: this.user.id,
                    uid: this.user.uid,
                    name: this.user.name,
                    photoURL: this.user.photoURL,
                    designation: this.user.designation,
                    company: this.user.company,
                  };
                  x[chair_id] = data;
                  $.$root.$emit("seatSelected", {tableId, chairId });
                  $.getAgoraTokenForVideoCall(tableId);
                }  else {
                  $.isSeatSelected = false;
                  x[chair_id] = ""
                  $.$toast.open({
                    message: "Someone is already there.",
                    type: "error",
                    position: "top",
                  });
                }
              }
            });
          } else {
            $.isSeatSelected = false;
            console.error(resp.data);
            $.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
            });
          }
        });
      } else {
        // handle double click
        // $.$toast.open({
        //   message: "User has already grabbed a seat",
        //   type: "info",
        //   position: "top",
        // });
        console.log("User has already grabbed a seat");
      }
    },
    listOfMembers: function() {
      const $ = this;
      // let da = {
      //   channel_id: $.$route.params.session,
      // };
      // $.$store.dispatch("getEventMembersData", da).then((resp) => {
      //   if (resp.data.status === "success") {
      //     $.memberList = resp.data.data;
      //     $.$store.state.members = resp.data.data;
      //   }
      // });
      $.mapIdTodata();
    },
    mapIdTodata() {
      const $ = this;
      $.$store.state.tables.forEach((x) => {
        if (x["chair_1"] !== "") {
          $.memberList.forEach((m) => {
            if (m.uid == x["chair_1"].uid) {
              if ($.$store.state.channelMembers.includes(m.uid)) {
                x["chair_1"] = m;
              }
            }
          });
        } else if (x["chair_2"] !== "") {
          $.memberList.forEach((m) => {
            if (m.uid == x["chair_2"].uid) {
              if ($.$store.state.channelMembers.includes(m.uid)) {
                x["chair_2"] = m;
              }
            }
          });
        } else if (x["chair_3"] !== "") {
          $.memberList.forEach((m) => {
            if (m.uid == x["chair_3"].uid) {
              if ($.$store.state.channelMembers.includes(m.uid)) {
                x["chair_3"] = m;
              }
            }
          });
        } else if (x["chair_4"] !== "") {
          $.memberList.forEach((m) => {
            if (m.uid == x["chair_4"].uid) {
              if ($.$store.state.channelMembers.includes(m.uid)) {
                x["chair_4"] = m;
              }
            }
          });
        }
      });
    },

    getScreenShareTableTokenFunction(tableId) {
      const $ = this;
      let data = {
        channel_id: this.$route.params.session,
        table_id: tableId,
      };
      // dispatch the api request to get data for token and uid
      this.$store.dispatch("getEventScreenShareTableToken", data).then((resp) => {
        if (resp.data.status === "success") {
          // Set the values for the token
          $.screenUid = resp.data.data.uid;
          $.screenShareToken = resp.data.data.rtc_token;
          // Call the screen share client
          $.screenShareClient();
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
          });
        }
      });
    },

    getAgoraTokenForVideoCall: function(tableId) {
      const $ = this;
      let data = {
        channel_id: this.$route.params.session,
        table_id: tableId,
      };
      this.$store.dispatch("getEventAgoraTableToken", data).then((resp) => {
        if (resp.data.status === "success") {
          $.videoTableToken = resp.data.data.rtc_token;
          $.tableChannel = resp.data.data.channel_name;
          $.talbeUid = resp.data.data.uid;
          $.handleClient();
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
          });
        }
      });
    },
    addStream(stream) {
      const $ = this;
      let repeatition = $.videoStreamList.some((item) => {
        return item.getId() == stream.getId();
      });

      if (repeatition) {
        return;
      }
       stream.preloadEffect(
        1,
        "https://meetbeans-data.s3.ap-south-1.amazonaws.com/enter2.wav",
        function(err) {
          if (err) {
            console.error("Failed to preload effect, reason: ", err);
          } else {
            console.log("Effect is preloaded successfully");
            stream.setEffectsVolume(10, function(err) {
              if (err) {
                console.error("Failed to set effects volume, reason: ", err);
              } else {
                console.log("Effects volume is set successfully");

            stream.playEffect(
              {
                soundId: 1,
                filePath: "https://meetbeans-data.s3.ap-south-1.amazonaws.com/enter2.wav",
              },
              function(err) {
                if (err) {
                  console.log("audio error");
                }
              }
            );
              }
              })
          }
        }
      );
      if ($.videoStreamList.length <= 17) {
        $.isSpeakerLoaderScreen = false;

        $.videoStreamList.push(stream);
        let no = $.videoStreamList.length;
        if (no > 0) {
          $.videoStreamList.map((item) => {
            let id = item.getId();
            // console.log("Vs Length: ", $.videoStreamList.length, " name: ", id);
            let canvas = document.querySelector("#screen-share-panel");

            let dom = document.querySelector("#ag-item-" + id);

            if (!dom) {
              dom = document.createElement("section");
              dom.setAttribute("id", "ag-item-" + id);
              dom.setAttribute("class", "ag-item");

              if (id === 100000001) {
                canvas = document.querySelector("#table-canvas");
                canvas.appendChild(dom);
                item.play("ag-item-" + id, { fit: "contain" });
              } else {
                canvas.appendChild(dom);
                item.play("ag-item-" + id);
                // document.getElementById(`video${id}`).style.height = "auto";
                // if (
                //   !document
                //     .getElementsByClassName("videoControlBtn")[0]
                //     .classList.contains("off")
                // ) {
                //   document
                //     .getElementsByClassName("videoControlBtn")[0]
                //     .classList.add("off");
                // let user_info = JSON.parse(localStorage.getItem("user_info"));
                // this.addImage(user_info);
                // $.memberList.map(m => {
                //   console.log('m : ', m);
                //   if(m.uid === id){
                //     this.addImage(m);
                //     item.muteVideo();
                //   }
                // })
                // }
              }
            }

            let length = $.videoStreamList.length;

            if ($.isScreenBeingSharedByRemote) {
              let bc = document.querySelector("#table-canvas");
              bc.setAttribute(
                "style",
                `display:flex; flex-wrap: wrap; flex-direction: row-reverse;overflow: hidden;`
              );

              let panel = document.querySelector("#screen-share-panel");
              panel.setAttribute(
                "style",
                `display: flex;flex-direction: column;width: 15%; height: 85vh;  z-index: 99;`
              );
              if (id !== 100000001) {
                if ($.videoStreamList.length < 8) {
                  dom.setAttribute(
                    "style",
                    `padding: 2px;width: 100%;height: 15vh`
                  );
                } else {
                  dom.setAttribute(
                    "style",
                    `padding: 2px;width: 50%;height: 10.62vh`
                  );
                }
              } else {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 100%;height: 85vh`
                );
              }
            } else {
              if (length == 1) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 100%;height: 0vh`
                );
              } else if (length == 2) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 50%;height: 85vh`
                );
              } else if (length >= 3 && length < 5) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 50%;height: 42.5vh`
                );
              } else if (length >= 5 && length < 7) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 33.3%;height: 42.5vh`
                );
              } else if (length >= 7 && length < 13) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 25%;height: 21.25vh`
                );
              } else if (length >= 13 && length < 18) {
                dom.setAttribute(
                  "style",
                  `padding: 2px;width: 20%;height: 21.25vh`
                );
              }
            }

            item.player.resize && item.player.resize();

            $.canvasLayout();

            setTimeout(function() {
              if (document.querySelector("#ag-item-" + id)) {
                const videoInfo = jquery("#video-info-" + id);
                console.log("video length: ", videoInfo, videoInfo.length);
                if (videoInfo.length <= 1) {
                  $.handleVideoInfo(item);
                }
                // document.querySelector(".ag-item").style.height = "85vh"
                // setTimeout(function() {
                //   $.isSpeakerLoaderScreen = false;
                // }, 1000);
              }
            }, 1000);
          });
        }
      } else {
        $.$toast.open({
          message: "Only 4 users can join at a time.",
          type: "error",
          position: "top",
        });
      }
    },
    updateConnectionStatus() {
      var connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      // console.log(
      //   "Connection type changed from " +
      //     this.networkState +
      //     " to " +
      //     connection.effectiveType
      // );
      this.networkState = connection.effectiveType;
    },
    handleVideoInfo(stream) {
      const $ = this;
      // video information code
      let styles = {
        position: "absolute",
        bottom: "120px",
        background: "rgba(10, 10, 10, 0.75)",
        color: "#fff",
        padding: "4px",
        "font-size": "12px",
        "font-weight": "bold",
        width: "120px",
        height: "60px",
      };
      if ($.isScreenBeingSharedByRemote) {
        styles = {
          position: "absolute",
          bottom: "0px",
          background: "rgba(10, 10, 10, 0.75)",
          color: "#fff",
          padding: "4px",
          "font-size": "12px",
          "font-weight": "bold",
          width: "120px",
          height: "27px",
        };
      }
      const targetElement = document.getElementById("player_" + stream.getId());
      if (targetElement === null) {
        return;
      }
      const videoInfo = document.getElementById(`video-info-${stream.getId()}`);
      if (typeof videoInfo != "undefined" && videoInfo != null) {
        return;
      }

      let da = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventMembersData", da).then((resp) => {
        if (resp.data.status === "success") {
          resp.data.data.forEach((m) => {
            if (m.uid == stream.getId()) {
              // if(document.querySelector(`user_photo_client_${m.uid}`) === null && m.uid != this.localStream.getId()) {
              //   $.addImage(m);
              // }
              const videoInfo = document.getElementById(`video-info-${stream.getId()}`);
              if (typeof videoInfo != "undefined" && videoInfo != null) {
                return;
              }
              const label = document.createElement("label");
              label.innerHTML = m.role.toUpperCase();
              if (m.role === "host") {
                label.setAttribute("class", "badge badge-danger");
              } else {
                label.setAttribute("class", "badge badge-info");
              }
              label.style.position = "absolute";
              label.style.left = "10px";
              label.style.top = "10px";
              label.style.zIndex = "9";
              targetElement.appendChild(label);
              let newElement = document.createElement("div");
              newElement.setAttribute("id", `video-info-${stream.getId()}`);
              newElement.setAttribute("class", "video-info");
              newElement.style.zIndex = "2";
              // const videoInfo = document.getElementById(`video-info-${m.uid}`);
              // if (typeof videoInfo != "undefined" && videoInfo != null) {
              //   return;
              // }
              if (m.company !== "" && m.designation !== "") {
                newElement.innerHTML = `<p id="m_name" style='color: #FFB229;font-size: 12px;padding-top: 4px;margin-bottom: 0px;'>${m.name}</p><p id="desg_cpy" style='margin-bottom: 0px;font-size: 10px'>${m.designation}, ${m.company}</p>`;
              } else {
                newElement.innerHTML = `<p id="m_name" style='color: #FFB229;font-size: 12px;padding-top: 4px;margin-bottom: 0px;'>${m.name}</p>`;
              }
              Object.assign(newElement.style, styles);
              targetElement.appendChild(newElement);
              if (stream.getId() != $.videoCalllocalStream.getId()) {
                const element = `
                    <div class="main-div" style="z-index:10000" >
                        <span class="audio-icon-div" style="z-index:10000">
                            <i class="fas fa-microphone-slash audio" type="button" style="display: none;background: transparent"></i>
                        </span>
                        <span class="video-icon-div" style="z-index:10000">
                            <i class="fas fa-video-slash video" type="button" style="display: none;background: transparent"></i>
                        </span>
                    </div>
                `;
                jquery(newElement).append(element);
              } else {
                // Yo
              }
            } else {
              // $.addImage(m);
            }
          });
        }
      });
    },
    removeStream(uid) {
      const $ = this;
      $.videoStreamList.map((item, index) => {
        if (item.getId() == uid) {
          item.close();
          let element = document.querySelector("#ag-item-" + uid);

          if (element) {
            element.parentNode.removeChild(element);
          }
          let tempList = [...$.videoStreamList];
          tempList.splice(index, 1);
          // // steamlist
          $.videoStreamList = tempList;
        }
      });
    },
    subscribeStreamEvents() {
      let $ = this;
      $.tableVideoClient.on("mute-audio", (evt) => {
        const $ = this;
        // console.log(
        //   "%c:this guy has muted audio-",
        //   "background: #ff00dd; color: #00ff00",
        //   evt.uid
        // );
        $.handleMuteAudio(evt.uid);
      });
      $.tableVideoClient.on("unmute-audio", (evt) => {
        const $ = this;
        // console.log(
        //   "%c:this guy has unmuted audio-",
        //   "background: #ff00dd; color: #00ff00",
        //   evt.uid
        // );
        $.handleUnmuteAudio(evt.uid);
      });
      $.tableVideoClient.on("mute-video", (evt) => {
        const $ = this;
        // console.log(
        //   "%c:this guy has muted video-",
        //   "background: #ff00dd; color: #00ff00",
        //   evt.uid
        // );
        $.$store.state.members.map((user) => {
          if (user.uid === evt.uid) {
            // console.log("User: ", user);
            let targetElement = document.getElementById(`player_${evt.uid}`);
            jquery(`#video${evt.uid}`).hide();
            var img = document.createElement("img");
            img.src = `${user.photoURL}`;
            img.style.position = "absolute";
            img.setAttribute("id", `user_photo_${evt.uid}`);
            img.style.top = "50%";
            img.style.left = "50%";
            img.style.transform = "translate(-50%, -50%)";
            // img.style.width = '80%'
            targetElement.appendChild(img);
            // targetElement.style.background = `url(${user.photoURL}) no-repeat center center/cover`
          }
        });

        $.handleMuteVideo(evt.uid);
        // console.log("Users: ", $.memberList);
      });
      $.tableVideoClient.on("unmute-video", (evt) => {
        const $ = this;
        // console.log(
        //   "%c:this guy has unmuted video-",
        //   "background: #ff00dd; color: #00ff00",
        //   evt.uid
        // );
        let userPhoto = document.getElementById(`user_photo_${evt.uid}`);
        userPhoto.remove();
        jquery(`#video${evt.uid}`).show();
        $.handleUnmuteVideo(evt.uid);
      });
      $.tableVideoClient.on("connection-state-change", () => {
        // console.log("TABLECLIENT: ", $.tableVideoClient);
        // console.log("TABLECLIENTNetwork: ", $.tableVideoClient.getNetworkStats);
        // console.log("TABLECLIENTSystem: ", $.tableVideoClient.getSystemStats);
        // console.log("TABLECLIENTtransport: ", $.tableVideoClient.getTransportStats);
        // console.log("TABLECLIENTDOWNLINK: ", $.tableVideoClient.networkQualityStats);
        // console.log(
        //   "ConnectionState: ",
        //   $.tableVideoClient.getConnectionState()
        // );
      });

      $.tableVideoClient.on("network-quality", (downLink) => {
        // console.log("Downlink: ", downLink);
        this.isOnline = downLink.downlinkNetworkQuality;
      });
      $.tableVideoClient.on("peer-online", (evt) => {
        console.log("peer-online", evt.uid);
        if (evt.uid === 100000001) {
          $.isScreenBeingSharedByRemote = true;
        }
      });
      $.tableVideoClient.on("stream-published", function(evt) {
        let localStream = evt.stream;
        console.log(localStream);
      });
      $.tableVideoClient.on("stream-added", function(evt) {
        let remoteStream = evt.stream;

        $.tableVideoClient.subscribe(remoteStream, function(err) {
          console.log("Subscribe stream failed", err);
        });
      });
      $.tableVideoClient.on("stream-subscribed", function(evt) {
        let remoteStream = evt.stream;
        // console.log("Got stream-subscribed event");
        // console.log(new Date().toLocaleTimeString());
        console.log(
          "Subscribe remote stream successfully: " + remoteStream.getId(), $.isScreenBeingSharedByRemote
        );
        $.videoStreamList.forEach(item => {
          if(item.getId() === 100000001){
            $.isScreenBeingSharedByRemote = true;
          }
        })
        $.addStream(remoteStream, true);

      });
      // When remote user leave
      $.tableVideoClient.on("peer-leave", function(evt) {
        // console.log("Peer has left: " + evt.uid);
        // console.log(new Date().toLocaleTimeString());
        // console.log(evt);
        $.removeStream(evt.uid);
        $.canvasLayout();
      });
      // Remote stream is removed
      $.tableVideoClient.on("stream-removed", function(evt) {
        let stream = evt.stream;
        // console.log("Stream removed: " + stream.getId());
        // console.log(new Date().toLocaleTimeString());
        // console.log(evt);
        $.removeStream(stream.getId());
        $.canvasLayout();
      });
    },
    streamInit(uid, attendeeMode, videoProfile, config) {
      // videoProfile, config - not being used
      let defaultConfig = {
        streamID: uid,
        audio: true,
        video: true,
        screen: false,
        cameraId: this.$store.state.cameraId,
        microphoneId: this.$store.state.microphoneId
      };
      switch (attendeeMode) {
        case "screenshare":
          defaultConfig.audio = false;
          defaultConfig.video = false;
          defaultConfig.screen = true;
          // defaultConfig.screenAudio = true;
          break;
        case "audio-only":
          defaultConfig.video = false;
          break;
        case "audience":
          defaultConfig.video = false;
          defaultConfig.audio = false;
          break;
        case "video":
          break;
        default:
          break;
      }
      let stream = AgoraRTC.createStream(merge(defaultConfig, config));
      // stream.setVideoProfile(videoProfile);
      stream.setVideoProfile("360p_1");
      return stream;
    },
    displayPanel(stream) {
      let dom = document.querySelector("#ag-item-" + stream.getId());
      // console.log("dom vs: ", dom, " asa", !dom, " stream: ", stream);

      if (!dom) {
        dom = document.createElement("section");
        dom.setAttribute("id", "ag-item-" + stream.getId());
        dom.setAttribute("class", "ag-item");
        dom.setAttribute(
          "style",
          "width: 150px;height: 100px;margin-bottom: 10px"
        );
        // let player = document.querySelector("#player_" + stream.getId());
        // player.style.position = "absolute";
        // player.style.left = "0";
        document.querySelector("#panel").appendChild(dom);
        stream.play("ag-item-" + stream.getId());
        let video = document.querySelector("#video" + stream.getId());
        video.style.left = "0";

      } else {
        document.querySelector("#panel").appendChild(dom);
        dom.setAttribute(
          "style",
          "width: 150px;height: 100px;margin-bottom: 10px"
        );
        // let player = document.querySelector("#player_" + stream.getId());
        // player.style.position = "absolute";
        // player.style.left = "0";
        stream.play("ag-item-" + stream.getId());

      let video = document.querySelector(`#video${stream.getId()}`);
      video.style.left = "0";
      }
    },
    initializeScreenStream() {
      const $ = this;
      // get token and uid for screen share
      $.getScreenShareTableTokenFunction($.localTableId);
    },
    screenShareClient() {
      const $ = this;
      // create the client fot screenshare
      $.tableScreenClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });

      $.tableScreenClient.init($.appID, () => {
        // console.log("AgoraRTC screen stream initialized");
        $.$root.$emit("screenShareLoaderStartForTable", $.localTableId);
        // $.subscribeScreenStreamEvents();
        // client join
        // console.log(
        //   "%c:$.tableChannel",
        //   "background: #ff00dd; color: #00ff00",
        //   $.screenShareToken,
        //   " ",
        //   $.tableChannel,
        //   " ",
        //   $.screenUid
        // );
        $.tableScreenClient.join(
          $.screenShareToken,
          $.tableChannel,
          $.screenUid,
          (uid) => {
            console.log(uid);
            const data = {
              screenUid: $.screenUid,
              attendeeMode: "screenshare",
              videoProfile: {},
              config: {},
            };
            $.tableScreenClient.enableDualStream(
              () => {
                console.log("Screen sharing dual stream");
              },
              (err) => {
                console.log("Screen sharing dual stream error: ", err);
              }
            );
            $.videoCallScreenStream = $.streamInit(
              data.screenUid,
              data.attendeeMode,
              data.videoProfile,
              data.config
            );
            $.videoCallScreenStream.init(
              () => {
                // console.log(
                //   "screen share id vs--: ",
                //   $.videoCallScreenStream.getId()
                // );
                $.isActiveTableScreenShare = true;
                $.$root.$emit(
                  "clientScreenShareStartedForTable",
                  $.videoCallScreenStream.getId()
                );

                $.addStream($.videoCallScreenStream, true);
                // $.$toast.open({
                //   message: "You are ready to chat with table members.",
                //   type: "success",
                //   position: "top",
                // });
                $.tableScreenClient.publish($.videoCallScreenStream, (err) => {
                  console.log("Publish local stream error: " + err);
                });
                setTimeout(() => {
                  $.$root.$emit("screenShareLoaderStopForTable", $.localTableId);
                }, 2000);
                // $.$root.$emit('submitSetting')
                // jquery(window).on("beforeunload", function() {
                //   return "Are you sure you want to leave?";
                // });

                // jquery(window).on("unload", function() {
                //   $.handleLeaveTable();
                // });
              },
              (err) => {
                $.$toast.open({
                  message: `${err.info}. Go to settings and allow permissions and reload.`,
                  type: `${err.type}`,
                  position: "top",
                });
                $.$root.$emit("screenShareLoaderStopForTable", $.localTableId);
                console.log("getUserMedia failed", err);
                $.handleStopScreenShare();
              }
            );
            $.videoCallScreenStream.on("stopScreenSharing", () => {
              // $.removeStream($.videoCalllocalStream.getId());
              $.isActiveTableScreenShare = false;
              $.isScreenBeingSharedByRemote = false;
              $.handleStopScreenShare();
            });
            // console.log(
            //   "%c:join screen share channel successfully with uid",
            //   "background: #ff00dd; color: #00ff00",
            //   uid
            // );
            // console.log(
            //   "%c:At",
            //   "background: #ff00dd; color: #00ff00",
            //   new Date().toLocaleTimeString()
            // );
          },
          (err) => {
            console.log("unable to create dummy client: ", err);
            $.removeStream($.videoCallScreenStream.getId());
          }
        );
      });
    },
    handleClient() {
      const $ = this;
      // client initialization
      $.tableVideoClient = AgoraRTC.createClient({
        mode: "rtc",
        codec: "vp8",
      });
      $.tableVideoClient.init($.appID, () => {
        // console.log("AgoraRTC client initialized");
        $.subscribeStreamEvents();
        // // client join
        // console.log(
        //   "%c:$.tableChannel",
        //   "background: #ff00dd; color: #00ff00",
        //   $.tableChannel
        // );
        $.tableVideoClient.join(
          $.videoTableToken,
          $.tableChannel,
          $.talbeUid,
          (uid) => {
            // console.log(
            //   "%c:typeof uid",
            //   "background: #ff0000; color: #00ff00",
            //   typeof uid
            // );
            $.tableVideoClient.enableDualStream(
              () => {
                // console.log("Table video dual stream enabled");
                $.talbeUid = uid;
                const data = {
                  talbeUid: $.talbeUid,
                  attendeeMode: "",
                  videoProfile: {},
                  config: {},
                };
                $.videoCalllocalStream = $.streamInit(
                  data.talbeUid,
                  data.attendeeMode,
                  data.videoProfile,
                  data.config
                );
                $.videoCalllocalStream.init(
                  () => {
                    $.addStream($.videoCalllocalStream, true);
                    $.$toast.open({
                      message: "You are ready to chat with table members.",
                      type: "success",
                      position: "top",
                    });
                    $.tableVideoClient.publish(
                      $.videoCalllocalStream,
                      (err) => {
                        console.log("Publish local stream error: " + err);
                      }
                    );
                    // $.$root.$emit('submitSetting')
                    // jquery(window).on("beforeunload", function() {
                    //   return "Are you sure you want to leave?";
                    // });

                    // jquery(window).on("unload", function() {
                    //   $.handleLeaveTable();
                    // });
                  },
                  (err) => {
                    $.$toast.open({
                      message: `${err.info}. Go to settings or allow permissions from your browser and refresh the page.`,
                      type: `${err.type}`,
                      position: "top",
                    });
                    console.log("getUserMedia failed", err);
                    if (err.info === "Permission denied") {
                      // handle Permission denied case
                    }
                  }
                );
              },
              (err) => {
                console.log("Table video dual stream error: ", err);
              }
            );
            // $.talbeUid = uid;
            // const data = {
            //   talbeUid: $.talbeUid,
            //   attendeeMode: "",
            //   videoProfile: {},
            //   config: {},
            // };
            // $.videoCalllocalStream = $.streamInit(
            //   data.talbeUid,
            //   data.attendeeMode,
            //   data.videoProfile,
            //   data.config
            // );
            // $.videoCalllocalStream.init(
            //   () => {
            //     $.addStream($.videoCalllocalStream, true);
            //     $.$toast.open({
            //       message: "You are ready to chat with table members.",
            //       type: "success",
            //       position: "top",
            //     });
            //     $.tableVideoClient.publish($.videoCalllocalStream, (err) => {
            //       console.log("Publish local stream error: " + err);
            //     });
            //     // $.$root.$emit('submitSetting')
            //     jquery(window).on("beforeunload", function() {
            //       return "Are you sure you want to leave?";
            //     });

            //     jquery(window).on("unload", function() {
            //       $.handleLeaveTable();
            //     });
            //   },
            //   (err) => {
            //     $.$toast.open({
            //       message: `${err.info}. Go to settings and allow permissions and reload`,
            //       type: `${err.type}`,
            //       position: "top",
            //     });
            //     console.log("getUserMedia failed", err);
            //   }
            // );
            // console.log(
            //   "%c:join video channel successfully with uid",
            //   "background: #ff00dd; color: #00ff00",
            //   uid
            // );
            // console.log(
            //   "%c:At",
            //   "background: #ff00dd; color: #00ff00",
            //   new Date().toLocaleTimeString()
            // );
            // create local stream
            // It is not recommended to setState in function addStream
            // $.attendeeMode - "audio-only", "audience", video"
            // $.videoProfile, $.config - passing deafult val ""
          }
        );
      });
    },
  },
  beforeUpdate() {
    let $ = this;

    $.mapIdTodata();
    this.listOfMembers();
  },
  beforeDestroy() {
    const $ = this;
    console.log('called...');
    this.handleLeaveTable();
    $.auditoriumAudio.pause();
    this.videoStreamList = [];
    $.$store.state.tables.forEach((table) => {
      if ($.localTableId == table.table_id) {
        table[`chair_${$.localChairId}`] = "";
        $.$root.$emit("deleteMeFromYourRecord", {
          tableId: $.localTableId,
          chairId: $.localChairId,
        });
      }
    });
    // let da = {
    //   channel_id: this.$route.params.session,
    // };
    // this.$store.dispatch("storeEventTableStructure", da).then((resp) => {
    //   if (resp.data.status === "success") {
    //     console.log("chair selected, store data.");
    //   } else {
    //     console.error(resp.data);
    //   }
    // });
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  position: relative;
  z-index: 100000;
  opacity: 1;
  // display: inline-block;
  // border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #1f1f1f;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: black transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  font-size: 14px;
}
.table-item:hover > *:not(.chair-label) {
  box-shadow: 5px 5px 0px rgba(0, 0, 0, .7);
}
#screen-share-panel {
  display: flex;
  flex-wrap: wrap;
  // transition: flex .3s ease-out;
}
.makeScreenView {
  display: none !important;
}
.make-video-view {
  display: block !important;
}
.round-table {
  padding-top: 19px;
  color: #ccc;
  box-shadow: 0px 0px 6px #000;
  width: 67.6px;
  height: 67.6px;
  background-color: #565656;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  border-radius: 35px;
  border: 1px solid #979797;
}
.round-table-loader {
  width: 67.6px;
  height: 67.6px;
  background-color: #ffb229;
  font-size: 10px;
  color: #000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  border-radius: 35px;
  padding-top: 21px;
}
#table-canvas {
  height: 100%;
  width: 100%;
  // z-index: 16;
  // position: absolute;
  display: flex;
  overflow: hidden;
  // transition: flex 0.2s;
}
.disableButton {
  pointer-events: none;
  background-color: grey !important;
}

.column-for-two {
  display: grid;
}

.ag-item :first-child {
  border-radius: 6px;
}

.ag-item {
  border-radius: 6px;
  /*border: 2px #fbaf28 solid;*/
  box-shadow: 0px 0px 2px #000;
  /* background: url("../assets/images/avatar.png") center no-repeat; */
  height: 100%;
  width: 100%;
}

.table-item {
  width: 230px;
  height: 250px;
  display: inline-block;
  position: relative;
  border-radius: 16px;
  margin: 5px;
}

.chair {
  width: 38.6px;
  height: 38.9px;
  background-color: #adacac;
  border: 1px solid #979797;
  z-index: 2;
  border-radius: 30%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.chair-up {
  top: calc(50% - 40px);
}

.chair-up:hover {
  transition: .5s ease-in-out;
  top: calc(50% - 60px);
}
.chair-down {
  top: calc(50% + 40px);
}
.chair-down:hover {
  transition: .5s ease-in-out;
  top: calc(50% + 60px);
}
.chair-right {
  left: calc(50% + 40px);
}
.chair-right:hover {
  transition: .5s ease-in-out;
  left: calc(50% + 60px);
}
.chair-left {
  left: calc(50% - 40px);
}
.chair-left:hover {
  transition: .5s ease-in-out;
  left: calc(50% - 60px);
}
.chair.chair-up::after {
  top: -4px;
}

.chair.chair-up::after {
  top: -4px;
}

.chair.chair-left::after {
  left: -4px;
  height: 38.89px;
  width: 7.9px;
}

.chair.chair-right::after {
  right: -4px;
  height: 38.89px;
  width: 7.9px;
}

.chair.chair-down::after {
  bottom: -4px;
}

.chair::after {
  display: block;
  content: "";
  width: 36.89px;
  height: 7.9px;
  background-color: rgb(140, 140, 140);
  position: absolute;
  border-radius: 30px;
}
/* button group */
.ag-btn-group {
  width: 100%;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 11;
  display: flex;
  background-image: linear-gradient(transparent, #000);
  justify-content: space-between;
  align-items: center;
}

/*.ag-btn-group:hover,*/
/*.ag-btn-group.active {*/
/*	background: rgba(0, 0, 0, 0.88);*/
/*}*/
.ag-btn {
  z-index: 12;
  /*opacity: 0;*/
  color: #feb22a;
  height: 45px;
  cursor: pointer;
  font-size: 20px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #1b1b1b;
  padding: 10px 15px;
  border: 1px solid #feb22a;
  border-radius: 12px;
  margin: 5px;
}

.ag-btn:hover {
  color: #fbaf28;
}

.ag-btn.disabled,
.ag-btn.disabled:hover {
  color: rgba(221, 214, 23, 0.79);
  cursor: not-allowed;
}

.ag-btn-group:hover .ag-btn,
.ag-btn-group.active .ag-btn {
  opacity: 1;
}

.ag-btn.off.videoControlBtn .fa-video {
  display: none;
}

.ag-btn.videoControlBtn .fa-video-slash {
  display: none;
}

.ag-btn.videoControlBtn .fa-video {
  display: inline-block;
}

.ag-btn.off.videoControlBtn .fa-video-slash {
  display: inline-block;
}

.ag-btn.off.audioControlBtn .fa-microphone {
  display: none;
}

.ag-btn.audioControlBtn .fa-microphone-slash {
  display: none;
}

.ag-btn.audioControlBtn .fa-microphone {
  display: inline-block;
}

.ag-btn.off.audioControlBtn .fa-microphone-slash {
  display: inline-block;
}

.ag-btn.fullscreenControlBtn {
  display: inline-block;
}

.table-image-preview-top {
  z-index: 1;
  width: 101%;
  position: absolute;
  top: -4px;
  left: 0px;
  border-radius: 3px;
}
.table-image-preview-right {
  z-index: 1;
  width: 101%;
  position: absolute;
  top: 0px;
  left: 6px;
  border-radius: 3px;
}

.table-image-preview-left {
  z-index: 1;
  width: 101%;
  position: absolute;
  top: 0px;
  left: -6px;
  border-radius: 3px;
}

.table-image-preview-bottom {
  z-index: 1;
  width: 101%;
  position: absolute;
  top: 4px;
  left: 0px;
  border-radius: 3px;
}
.chair-label {
  position: absolute;
  left: -57px;
  top: 2px;
  width: 200px;
  padding: 4px;
  font-size: 10px;
}

// Tooltip

.chair-right {
  position: relative;
}

.chair .tooltiptext {
  visibility: hidden;
  width: 175px;

  background-color: #fff;
  color: #101010;
  text-align: center;
  padding: 5px 0;
  border-radius: 8px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: 5px;
  left: 125%;
  z-index: 100000;
}

.chair-up .tooltiptext-top {
  visibility: hidden;
  width: 175px;

  background-color: #fff;
  color: #101010;
  text-align: center;
  padding: 5px 0;
  border-radius: 8px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: -30px;
  left: 125%;
  z-index: 100000;
}

.chair-up:hover .tooltiptext-top {
  visibility: visible;
}

.chair .Triangle {
  visibility: hidden;
  // width: 12px;
  // height: 12px;
  // transform: rotate(90deg);
  // border-radius: 1px;
  // background-color: #ffffff;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-right: 10px solid #fff;
  border-bottom: 5px solid transparent;
  position: absolute;
  top: 10px;
  left: 95%;
  z-index: 10000;
}

/* Show the tooltip text when you mouse over the tooltip container */
.chair:hover .tooltiptext {
  visibility: visible;
}

.chair:hover .Triangle {
  visibility: visible;
}

.chair-left .tooltiptext-left {
  visibility: hidden;
  width: 175px;
  background-color: #fff;
  color: #101010;
  text-align: center;
  padding: 5px 0;
  border-radius: 8px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: -70px;
  right: 55%;
  z-index: 100000;
}

.chair-left .Triangle-left {
  visibility: hidden;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #fff;
  border-bottom: 5px solid transparent;
  position: absolute;
  top: -30%;
  left: 1%;
}

.chair-left:hover .tooltiptext-left {
  visibility: visible;
}

.chair-left:hover .Triangle-left {
  visibility: visible;
}

.chair-right .tooltiptext-right {
  visibility: hidden;
  width: 175px;

  background-color: #fff;
  color: #101010;
  text-align: center;
  padding: 5px 0;
  border-radius: 8px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: -70px;
  left: 75%;
  z-index: 100000;
}

.chair-right .Triangle-right {
  visibility: hidden;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #fff;
  position: absolute;
  top: -10px;
  left: 90%;
}

.chair-right:hover .tooltiptext-right {
  visibility: visible;
}

.chair-right:hover .Triangle-right {
  visibility: visible;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) {
  .table-item {
    width: 250px;
    height: 250px;
  }
}

@media only screen and (max-width: 575px) {
  .chair-label {
    left: 17px;
  }
  #table-canvas {
    width: 100vw;
  }
  .column-for-two {
    display: flex !important;
    flex-direction: column;
  }
}
#video-info {
  z-index: 1;
}
.video-info {
  position: absolute;
  top: 42px;
  left: 10px;
  z-index: 100;
}
video {
  object-fit: contain;
}
.social-header {
  width: 100%;
  height: auto;
  margin-bottom: 2%;
  text-align: center;
  background: url(../../assets/stage.png) no-repeat center center;
}
#offline {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  z-index: 100;
  background: rgba(10, 10, 10, 0.75);
  padding: 5%;
  font-size: 1.5rem;
}

#offline_user {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 6px;
  z-index: 100;
  background: rgba(10, 10, 10, 0.75);
  padding: 5%;
}
</style>
